/**
 * DISCOUNT DETECTOR - VERSIÓN FINAL
 * 
 * Detecta si el usuario llegó vía link de descuento usando parámetro ?origen=descuento
 * 
 * URL FINAL (después del redirect):
 * /products/vision-board?origen=descuento
 * 
 * Si existe ?origen=descuento:
 * - Muestra banner informativo
 * - Aplica descuento basado en el CÓDIGO del producto
 * 
 * Códigos soportados:
 * - VISION50OFF (50% descuento)
 * - CONFERENCIA50OFF (50% descuento)
 */

(function() {
  'use strict';

  console.log('[Discount] Script iniciado');

  // ============================================
  // CONFIG
  // ============================================
  const DISCOUNT_CODES = {
    'VISION50OFF': 50,
    'CONFERENCIA50OFF': 50
  };

  // ============================================
  // DETECTAR SI VIENE DE LINK DE DESCUENTO
  // ============================================
  function detectarDesdeDescuento() {
    const params = new URLSearchParams(window.location.search);
    const origen = params.get('origen');
    
    if (origen === 'descuento') {
      console.log('[Discount] ✓ Detectado: usuario llegó desde link de descuento');
      return true;
    }
    
    console.log('[Discount] ✗ No viene de link de descuento');
    return false;
  }

  // ============================================
  // EXTRAER CÓDIGO DE DESCUENTO DEL PRODUCTO
  // ============================================
  function extraerCodigoDelProducto() {
    // Intentar múltiples formas de encontrar el nombre del producto
    
    // Opción 1: Del atributo data-product-handle
    let handle = document.querySelector('[data-product-handle]')?.getAttribute('data-product-handle');
    if (handle) {
      console.log('[Discount] Nombre del producto (handle):', handle);
      
      // Mapeo manual: handle -> código de descuento
      if (handle === 'vision-board') {
        return 'VISION50OFF';
      }
      if (handle === 'codigo-del-negocio-millonario-la-conferencia') {
        return 'CONFERENCIA50OFF';
      }
    }

    // Opción 2: Del objeto window.theme (si está disponible)
    if (window.theme && window.theme.productHandle) {
      console.log('[Discount] Nombre del producto (window.theme):', window.theme.productHandle);
      
      if (window.theme.productHandle === 'vision-board') {
        return 'VISION50OFF';
      }
      if (window.theme.productHandle === 'codigo-del-negocio-millonario-la-conferencia') {
        return 'CONFERENCIA50OFF';
      }
    }

    // Opción 3: De la URL actual
    const urlPath = window.location.pathname;
    console.log('[Discount] URL path:', urlPath);
    
    if (urlPath.includes('vision-board')) {
      return 'VISION50OFF';
    }
    if (urlPath.includes('codigo-del-negocio-millonario-la-conferencia')) {
      return 'CONFERENCIA50OFF';
    }

    console.log('[Discount] No se pudo extraer código del producto');
    return null;
  }

  // ============================================
  // MOSTRAR BANNER (DESHABILITADO)
  // ============================================
  function mostrarBanner(codigo, porcentaje) {
    console.log('[Discount] Banner deshabilitado');
    // Banner removido - solo mostrar precio
  }

  // ============================================
  // MOSTRAR PRECIO CON DESCUENTO
  // ============================================
  function mostrarPrecioConDescuento(porcentaje) {
    console.log('[Discount] Mostrando precio con descuento...');

    // ESTRATEGIA: Obtener el precio del JSON del producto (más confiable que parsear HTML)
    fetch(window.location.pathname + '.js')
      .then(res => res.json())
      .then(data => {
        if (!data.variants || data.variants.length === 0) {
          console.log('[Discount] ✗ No hay variantes en el JSON del producto');
          return;
        }

        // Obtener el primer variant disponible (o el seleccionado)
        const variant = data.variants[0];
        const precioEnCentavos = variant.price; // Shopify devuelve en centavos
        const precioOriginal = precioEnCentavos / 100;

        console.log('[Discount] ✓ Precio del JSON:', precioOriginal);

        const precioConDescuento = precioOriginal * (1 - porcentaje / 100);

        console.log('[Discount] ✓ Precio calculado:', {
          original: precioOriginal,
          conDescuento: precioConDescuento,
          porcentaje: porcentaje
        });

        // Buscar elemento de precio en el DOM
        const selectores = [
          '[data-product-price]',
          '[data-a11y-price]',
          '.product-price',
          '[class*="price"]'
        ];

        let elementoPrecio = null;
        for (const sel of selectores) {
          elementoPrecio = document.querySelector(sel);
          if (elementoPrecio) {
            console.log('[Discount] Elemento de precio encontrado:', sel);
            break;
          }
        }

        if (!elementoPrecio) {
          console.log('[Discount] ✗ No se encontró elemento de precio en el DOM');
          return;
        }

        // Crear elemento con precio con descuento
        const contenedor = document.createElement('div');
        contenedor.className = 'ag-discount-price';
        
        contenedor.innerHTML = `
          <div style="
            display: flex;
            align-items: center;
            gap: 12px;
            margin-top: 8px;
            flex-wrap: wrap;
          ">
            <span style="
              text-decoration: line-through;
              color: #999;
              font-size: 14px;
              font-family: inherit;
            ">$${precioOriginal.toFixed(2)}</span>
            
            <span style="
              font-weight: bold;
              color: #d81e05;
              font-size: 18px;
              font-family: inherit;
            ">$${precioConDescuento.toFixed(2)}</span>
            
            <span style="
              background: #d81e05;
              color: white;
              padding: 4px 8px;
              border-radius: 4px;
              font-size: 12px;
              font-weight: bold;
              white-space: nowrap;
              font-family: inherit;
            ">${porcentaje}% OFF</span>
          </div>
        `;

        // Insertar después del precio original
        if (elementoPrecio.nextSibling) {
          elementoPrecio.parentNode.insertBefore(contenedor, elementoPrecio.nextSibling);
        } else {
          elementoPrecio.parentNode.appendChild(contenedor);
        }

        console.log('[Discount] ✓ Precio con descuento mostrado');
      })
      .catch(err => {
        console.log('[Discount] ✗ Error obteniendo JSON del producto:', err);
      });
  }

  // ============================================
  // INICIALIZAR
  // ============================================
  function inicializar() {
    console.log('[Discount] Inicializando...');

    // Paso 1: Verificar si viene de link de descuento
    if (!detectarDesdeDescuento()) {
      console.log('[Discount] Script finaliza (no hay descuento)');
      return;
    }

    // Paso 2: Extraer código del producto
    const codigo = extraerCodigoDelProducto();
    if (!codigo) {
      console.log('[Discount] ✗ No se encontró código de descuento para este producto');
      return;
    }

    // Paso 3: Obtener porcentaje
    const porcentaje = DISCOUNT_CODES[codigo];
    if (!porcentaje) {
      console.log('[Discount] ✗ Código no está en DISCOUNT_CODES:', codigo);
      return;
    }

    console.log('[Discount] ✓ Descuento detectado:', { codigo, porcentaje });

    // Paso 4: Esperar a que el DOM esté listo
    const mostrar = () => {
      console.log('[Discount] DOM listo, mostrando interfaces...');
      mostrarBanner(codigo, porcentaje);
      mostrarPrecioConDescuento(porcentaje);
      console.log('[Discount] ✓ Script completado exitosamente');
    };

    if (document.readyState === 'loading') {
      console.log('[Discount] Esperando DOMContentLoaded...');
      document.addEventListener('DOMContentLoaded', mostrar);
    } else {
      mostrar();
    }
  }

  // ============================================
  // DETECTOR DE BUNDLE (10 items = PAQUETE10)
  // Usa /discount/PAQUETE10 (URL nativa de Shopify)
  // porque /cart/update.js NO soporta discount_code
  // ============================================
  let bundleIntervalId = null;
  let bundleLastNotifiedState = null;
  let bundleRedirecting = false;

  function monitorearCarrito() {
    console.log('[Bundle] Iniciando monitoreo de carrito...');

    async function verificarYAplicarBundle() {
      // No verificar si ya estamos en proceso de redirect
      if (bundleRedirecting) return;
      
      try {
        const res = await fetch('/cart.json');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        
        const cart = await res.json();
        const totalItems = cart.items.reduce(function(sum, item) { return sum + item.quantity; }, 0);
        
        // Verificar si ya viene con PAQUETE10 aplicado (después del redirect)
        var hasPaquete10 = false;
        if (cart.cart_level_discount_applications) {
          hasPaquete10 = cart.cart_level_discount_applications.some(function(d) {
            return d.title === 'PAQUETE10';
          });
        }
        // También verificar en items por line-level discounts
        if (!hasPaquete10 && cart.items.length > 0) {
          hasPaquete10 = cart.items.some(function(item) {
            return item.discounts && item.discounts.some(function(d) {
              return d.title === 'PAQUETE10';
            });
          });
        }
        
        // Solo log si cambió el estado
        var currentState = totalItems + '-' + hasPaquete10;
        if (currentState !== bundleLastNotifiedState) {
          console.log('[Bundle] Estado del carrito - Items: ' + totalItems + ', PAQUETE10 aplicado: ' + hasPaquete10);
          bundleLastNotifiedState = currentState;
        }

        // Si hay exactamente 10 items Y no tiene PAQUETE10 aplicado
        if (totalItems === 10 && !hasPaquete10) {
          // Verificar que no acabamos de venir de un redirect (evitar loop)
          var params = new URLSearchParams(window.location.search);
          if (params.get('paquete_applied') === '1') {
            console.log('[Bundle] Ya se intentó aplicar PAQUETE10 via redirect - no repetir');
            clearInterval(bundleIntervalId);
            bundleIntervalId = null;
            return;
          }

          console.log('[Bundle] ✓ Detectados 10 items - Redirigiendo a /discount/PAQUETE10...');
          bundleRedirecting = true;
          clearInterval(bundleIntervalId);
          bundleIntervalId = null;
          
          // Usar la URL nativa de Shopify para aplicar descuentos
          window.location.href = '/discount/PAQUETE10?redirect=/cart?paquete_applied=1';
          return;
        }
        
        // Si tiene 10 items y ya tiene el descuento, éxito
        if (totalItems === 10 && hasPaquete10) {
          console.log('[Bundle] ✅ PAQUETE10 activo con 10 items - Deteniendo monitoreo');
          clearInterval(bundleIntervalId);
          bundleIntervalId = null;
        }
      } catch (err) {
        console.error('[Bundle] ✗ Error verificando carrito:', err.message);
      }
    }

    // Verificar inmediatamente
    console.log('[Bundle] Primera verificación...');
    verificarYAplicarBundle();
    
    // Verificar cada 3 segundos
    if (!bundleIntervalId) {
      bundleIntervalId = setInterval(verificarYAplicarBundle, 3000);
    }
    
    console.log('[Bundle] Monitoreo iniciado');
  }

  // Iniciar monitoreo del bundle SOLO en la página del carrito
  function inicializarBundle() {
    // Solo correr en /cart (no en todas las páginas)
    if (window.location.pathname.indexOf('/cart') !== 0) {
      console.log('[Bundle] No estamos en /cart - monitoreo no necesario');
      return;
    }

    console.log('[Bundle] Función inicializarBundle llamada (en /cart)');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        console.log('[Bundle] DOMContentLoaded - iniciando monitoreo');
        monitorearCarrito();
      });
    } else {
      console.log('[Bundle] DOM ya cargado - iniciando monitoreo directamente');
      monitorearCarrito();
    }
  }

  // EJECUTAR - El bundle monitoring corre siempre (independiente del producto discount)
  console.log('[Discount] Script iniciando - modo iniciación de funciones');
  inicializar();
  inicializarBundle();

})();
